import { Mail, Instagram } from "lucide-react";
import { siteConfig, navLinks, mailtoUrl, whatsappUrl, instagramUrl } from "../../config/siteConfig";
import { WhatsAppIcon } from "./icons";

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            id="contato"
            data-testid="footer"
            className="py-12 bg-[#080a0e] border-t border-[#1a202c]"
        >
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8 pb-8 border-b border-[#1a202c]">
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <img
                                src="/images/logo-mark.png"
                                alt="Linkora"
                                className="h-8 w-8 object-contain"
                            />
                            <span className="font-bold text-white text-base">linkora</span>
                        </div>
                        <p className="text-xs text-slate-400 max-w-sm">
                            Criação de sites profissionais para empresas e negócios.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-6 text-xs text-slate-400">
                        {navLinks.map((link) => (
                            <a
                                key={link.id}
                                href={`#${link.id}`}
                                data-testid={`footer-link-${link.id}`}
                                className="hover:text-white transition-colors"
                            >
                                {link.label}
                            </a>
                        ))}
                        <a
                            href="#orcamento"
                            data-testid="footer-link-orcamento"
                            className="hover:text-white transition-colors"
                        >
                            Orçamento
                        </a>
                    </div>

                    <div className="md:text-right">
                        <span className="text-xs text-slate-400 block mb-1">Contato oficial</span>
                        <a
                            href={mailtoUrl}
                            data-testid="footer-email"
                            className="code-font text-xs text-blue-400 font-semibold hover:text-blue-300 transition-colors flex items-center gap-1.5 md:justify-end"
                        >
                            <Mail className="w-3.5 h-3.5" />
                            {siteConfig.email}
                        </a>
                        {(instagramUrl || whatsappUrl) && (
                            <div className="flex flex-wrap gap-3 mt-4 md:justify-end">
                                {instagramUrl && (
                                    <a
                                        href={instagramUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="footer-instagram"
                                        className="px-3 py-2 rounded-md border border-[#263142] text-slate-300 hover:text-white hover:border-[#2563eb]/60 transition-colors flex items-center gap-2 text-xs"
                                    >
                                        <Instagram className="w-4 h-4" />
                                        Acompanhe a Linkora
                                    </a>
                                )}
                                {whatsappUrl && (
                                    <a
                                        href={whatsappUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="footer-whatsapp"
                                        className="px-3 py-2 rounded-md border border-[#263142] text-slate-300 hover:text-white hover:border-[#2563eb]/60 transition-colors flex items-center gap-2 text-xs"
                                    >
                                        <WhatsAppIcon className="w-4 h-4" />
                                        Falar pelo WhatsApp
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-slate-500 gap-4">
                    <p>&copy; {year} Linkora. Todos os direitos reservados.</p>
                    <span className="code-font text-[11px] text-slate-600">{siteConfig.domain}</span>
                </div>
            </div>
        </footer>
    );
};
